import React from "react";

function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "#0B5CAD",
        color: "#ffffff",
        padding: "20px 0",
        marginTop: "40px",
      }}
    >
      <div className="container text-center">
        <p style={{ marginBottom: "8px", fontWeight: 600 }}>
          Electromates Robotics & Automation (India) Pvt. Ltd.
        </p>
        <p style={{ marginBottom: "8px", fontSize: "14px" }}>
          Simplifying Automation. Empowering Sustainability
        </p>
        <p style={{ marginBottom: 0, fontSize: "14px" }}>
          © 2026 Electromates. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;